import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class LoggedInGuard  {
  constructor(private readonly router: Router, private readonly authService: AuthService) {}

  canActivate(): boolean {
    if (this.authService.isTokenValid()) {
      this.router.navigate(['']);
      return false;
    }
    return true;
  }
}
